<!--
 * @Author: zengkai zengkai0702@gamil.com
 * @Date: 2025-08-14 10:21:43
 * @LastEditors: zengkai zengkai0702@gamil.com
 * @LastEditTime: 2025-09-09 12:03:08
 * @FilePath: /sq_admin_web_h5/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <van-config-provider :theme-vars="themeVars">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="cachedViews">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </van-config-provider>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

const themeVars = {
  primaryColor: "#4b7efe", // 定制主题色
  buttonPrimaryBackground: "#4b7efe",
};

const router = useRouter();
const cachedViews = ref([]);

// 监听路由变化，动态管理缓存
watch(
  () => router.currentRoute.value,
  (to, from) => {
    console.log("路由变化:", {
      to: to.name,
      from: from?.name,
      keepAlive: to.meta?.keepAlive,
    });

    // 如果当前页面需要缓存
    if (to.meta?.keepAlive && to.name) {
      if (!cachedViews.value.includes(to.name)) {
        cachedViews.value.push(to.name);
        console.log("添加缓存:", to.name, "当前缓存列表:", cachedViews.value);
      }
    }

    // 如果从缓存页面离开且需要清除缓存
    if (from && from.meta?.keepAlive && from.meta?.clearCache && from.name) {
      const index = cachedViews.value.indexOf(from.name);
      if (index > -1) {
        cachedViews.value.splice(index, 1);
        console.log("清除缓存:", from.name, "当前缓存列表:", cachedViews.value);
      }
    }
  },
  { immediate: true }
);

// 清除指定页面缓存的方法
const clearPageCache = (pageName) => {
  const index = cachedViews.value.indexOf(pageName);
  if (index > -1) {
    cachedViews.value.splice(index, 1);
    console.log("手动清除缓存:", pageName, "当前缓存列表:", cachedViews.value);
  }
};

// 监听清除缓存事件
const handleClearCache = (event) => {
  clearPageCache(event.detail.pageName);
};

// 监听登录过期清除所有缓存
const handleClearAllCache = () => {
  cachedViews.value = [];
  console.log("登录过期，清除所有页面缓存");
};

onMounted(() => {
  window.addEventListener("clearPageCache", handleClearCache);
  window.addEventListener("clearHomeData", handleClearAllCache);
});

onUnmounted(() => {
  window.removeEventListener("clearPageCache", handleClearCache);
  window.removeEventListener("clearHomeData", handleClearAllCache);
});
</script>
